<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Resume</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div style="width: 100%" class="mt-3">
        <CCol sm="12">
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
        </CCol>
      </div>
    </div>
    <CCard class="custom-card h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <h5
                class="text-left mt-4 text-black bold display-7-title"
              >
                Teacher Profile
              </h5>
              <CRow class="justify-content-center">
                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-1 mt-1"
                >
                  <div class="text-center custom-width-lg p-0 mb-3">
                    <CRow class="justify-content-center p-0">
                      <CCol sm="12" lg="12">
                        <CRow class="">
                          <CCol sm="12" lg="12" class="mt-4">
                            <span class="mr-2">
                              <img
                                :src="photoURL"
                                class="grey lighten-2 rounded-img img-profile mr-2 mt-2"
                              />
                            </span>
                            <CRow
                              class="row"
                            >
                              <CCol style="word-break: break-word;" sm="12" lg="12" class="text-left">
                                <!-- <CIcon name="cil-user" width="18px" class="text-muted" /> -->
                                <span class="display-6 mt-1">
                                  <strong>
                                  <b>  {{ teacherProfile.userName }} </b>
                                  </strong></span
                                >
                              </CCol>
                              <CCol style="word-break: break-word;" sm="12" lg="12" class="text-left mt-1">
                                <!-- <CIcon name="cil-envelope-open" width="18px"  class="text-muted" /> -->
                                <span class="display-6-personal mt-1">
                                  <strong>
                                    {{ teacherProfile.userEmail }}
                                  </strong></span
                                >
                              </CCol>
                              <CCol style="word-break: break-word;" sm="12" lg="12" class="text-left mt-1">
                                  <!-- <CIcon name="cil-address-book" width="18px"  class="text-muted" /> -->
                                <span class="display-6-personal mt-1">
                                  <strong>
                                 Phone : {{ teacherProfile.phoneNumber }}  /  Race :
                                    {{
                                      teacherProfile.userRace == null
                                        ? "None"
                                        : teacherProfile.userRace
                                    }}
                                  </strong></span
                                >
                              </CCol>
                             
                            </CRow>
                          </CCol>

                          <hr class="bottom_expandbar" />
                          <CCol sm="12" lg="12" class="d-flex">
                            <h5
                              class="text-left d-flex text-black bold display-7-title"
                              style="width: 100%"
                            >
                              Class and Grade
                            </h5>
                            <span
                              @click="GoToPageClassAndGrade()"
                              class="float-right mr-2"
                            >
                              <CIcon name="cil-pencil" width="20px" />
                              <!-- <img
                                src="../assets/img/settingGear.png"
                                height="25px"
                                width="25px"
                                class="float-right mr-2"
                              /> -->
                            </span>
                          </CCol>
                          <CCol sm="12" lg="12" class="">
                            <CRow class="">
                              <CCol sm="12" class="ml-4">
                                <span
                                  v-for="item in teacherSubGra"
                                  v-bind:key="item.subjectName"
                                  class="p-1 d-inline-flex"
                                >
                                  <span class="">
                                    <CBadge
                                      shape="default"
                                      color="light"
                                      class="mt-2 display-6"
                                    >
                                      {{
                                        " " +
                                        item.subjectName +
                                        " (" +
                                        item.gradeName +
                                        ")"
                                      }}
                                    </CBadge>
                                  </span>
                                </span>
                              </CCol>
                            </CRow>
                          </CCol>
    <hr class="bottom_expandbar" />
                          <CCol sm="12" lg="12" class="">
                            <h5
                              class="text-left mt-1 text-black bold display-7-title"
                              style="width: 100%"
                            >
                              Academic Profile
                            </h5>
                            <span
                              @click="GoToPageTeacherAcademicProfile()"
                              class="float-right mr-2"
                            >
                              <CIcon name="cil-pencil" width="20px" />
                            </span>
                          </CCol>
                          <CCol
                            sm="12"
                            lg="12"
                            class="mt-4 mb-4 justify-content-center"
                          >
                            <CRow
                              class="row justify-content-center"
                            >
                              <CCol sm="12" lg="12" class="text-left">
                                <span class="float-center display-6 text-left">
                                  <strong>
                                    {{
                                      teacherAcademic == null
                                        ? "None"
                                        : teacherAcademic.Content
                                    }}
                                  </strong></span
                                >
                              </CCol>
                            </CRow>
                          </CCol>
                              <hr class="bottom_expandbar" />

                          <CCol sm="12" lg="12" class="">
                            <h5
                              class="text-left mt-1 text-black bold display-7-title"
                              style="width: 100%"
                            >
                              Work Background
                            </h5>
                            <span
                              @click="GoToPageTeacherWorkBackground()"
                              class="float-right mr-2"
                            >
                              <CIcon name="cil-pencil" width="20px" />
                            </span>
                          </CCol>
                          <CCol
                            sm="12"
                            lg="12"
                            class="mt-4 mb-4 "
                          >
                            <CRow class="row">
                              <CCol sm="12" lg="12" class="text-left">
                                <span class="float-center display-6 text-left">
                                  <strong>
                                    {{
                                      teacherWorkBackground == null
                                        ? "None"
                                        : teacherWorkBackground.Content
                                    }}
                                  </strong></span
                                >
                              </CCol>
                            </CRow>
                          </CCol>
                              <hr class="bottom_expandbar" />

                          <CCol sm="12" lg="12" class="">
                            <h5
                              class="text-left mt-1 text-black bold display-7-title"
                              style="width: 100%"
                            >
                              Professional Profile
                            </h5>
                            <span
                              @click="GoToPageTeacherProfession()"
                              class="float-right mr-2"
                            >
                              <CIcon name="cil-pencil" width="20px" />
                            </span>
                          </CCol>
                          <CCol
                            sm="12"
                            lg="12"
                            class="mt-4 mb-4 justify-content-center"
                          >
                            <CRow
                              class="row justify-content-center"
                            >
                              <CCol sm="12" lg="12" class="mt-2 text-left">
                                <span class="float-center display-6 text-left">
                                  <strong>
                                    {{
                                      teacherProfessional == null
                                        ? "None"
                                        : teacherProfessional.Content
                                    }}
                                  </strong></span
                                >
                              </CCol>
                            </CRow>
                          </CCol>
    <hr class="bottom_expandbar" />
                          <CCol sm="12" lg="12" class="">
                            <h5
                              class="text-left mt-1 text-black bold display-7-title"
                              style="width: 100%"
                            >
                              Area of Expertise
                            </h5>
                            <span
                              @click="GoToPageTeacherAreaExpertise()"
                              class="float-right mr-2"
                            >
                              <CIcon name="cil-pencil" width="20px" />
                            </span>
                          </CCol>
                          <CCol
                            sm="12"
                            lg="12"
                            class="mt-4 mb-4"
                          >
                            <CRow class="row">
                              <CCol sm="12" lg="12" class="text-left">
                                <span class="float-center display-6 text-left">
                                  <strong>
                                    {{
                                      teacherAreasOfExpertise == null
                                        ? "None"
                                        : teacherAreasOfExpertise.Content
                                    }}
                                  </strong></span
                                >
                              </CCol>
                            </CRow>
                          </CCol>
                        </CRow>
                        <!-- <div>
                          <CButton
                            color="info"
                            class="custom-btn ml-2 mr-2 mb-2"
                            @click="SaveResume"
                            block
                            >Update</CButton
                          >
                        </div> -->
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>     
<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);
import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

export default {
  name: "Login",
  components: {
    PulseLoader,
  },
  data() {
    return {
      backgroundBanner,
      teacherProfile: {},
      teacherSubGra: [],
      teacherAcademic: {},
      teacherWorkBackground: {},
      teacherAreasOfExpertise: {},
      teacherProfessional: {},
      photoURL: "",
    };
  },
  async mounted() {
    await this.GetUserProfile();
    await this.GetTeacherSubjectGrade();
    await this.GetAcademiceProfile();
    await this.GetWorkBackground();
    await this.GetAreaofExpertise();
    await this.GetProfessionalProfile();
  },

  methods: {
    async GetUserProfile() {
      this.$API
        .get(this.$TeacherProfile + "?userId=" + this.$route.query.userId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherProfile = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.teacherProfile.filepath;
            $("#profileImage").text(this.photoURL);
          }
        });
    },
    async GetTeacherSubjectGrade() {
      this.$API
        .get(
          this.$TeacherSubjectGrade + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherSubGra = response.data;
          }
        });
    },
    async GetAcademiceProfile() {
      this.$API
        .get(
          this.$TeacherAcademiceProfile + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherAcademic = response.data;
          } else {
            this.teacherAcademic = null;
          }
        });
    },
    async GetWorkBackground() {
      this.$API
        .get(
          this.$TeacherWorkBackground + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherWorkBackground = response.data;
          } else {
            this.teacherWorkBackground = null;
          }
        });
    },
    async GetAreaofExpertise() {
      this.$API
        .get(
          this.$TeacherAreasOfExpertise + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherAreasOfExpertise = response.data;
          } else {
            this.teacherAreasOfExpertise = null;
          }
        });
    },
    async GetProfessionalProfile() {
      this.$API
        .get(
          this.$TeacherProfessional + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherProfessional = response.data;
          } else {
            this.teacherProfessional = null;
          }
        });
    },
    SaveResume() {
      this.UpdateProfessionalProfile();
      this.UpdateAreaOfExpertise();
    },
    UpdateProfessionalProfile() {
      if (this.TeacherId == undefined) {
        const formData = new FormData();
        formData.append("Id", 0);
        formData.append("TeacherId", this.$route.query.userId);
        formData.append("Content", this.ProfessionalName);
        formData.append("Status", "active");

        return this.$API
          .post(this.$UpdateProfessionalProfile, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.$dialog
                .alert("You have successfully save the professional profile")
                .then(function (dialog) {
                  //console.log("Closed");
                });
            }
          })
          .catch((error) => {
            if (error.response) {
              //console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      } else {
        const formData = new FormData();
        formData.append("TeacherId", this.TeacherId);
        formData.append("Id", this.ProfessionalId);
        formData.append("Content", this.ProfessionalName);
        formData.append("Status", "active");

        return this.$API
          .post(this.$UpdateProfessionalProfile, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.$dialog
                .alert("You have successfully save the professional profile")
                .then(function (dialog) {
                  console.log("Closed");
                });
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      }
    },
    UpdateAreaOfExpertise() {
      if (this.TeacherId == undefined) {
        const formData = new FormData();

        formData.append("TeacherId", this.$route.query.userId);
        formData.append("Id", 0);
        formData.append("Content", this.AreaExpertise);
        formData.append("Status", "active");

        return this.$API
          .post(this.$UpdateAreaOfExpertise, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.$dialog
                .alert("You have successfully save the area of expertise")
                .then(function (dialog) {
                  //console.log("Closed");
                });
            }
          })
          .catch((error) => {
            if (error.response) {
              //console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      } else {
        const formData = new FormData();

        formData.append("TeacherId", this.TeacherId);
        formData.append("Id", this.AreaId);
        formData.append("Content", this.AreaExpertise);
        formData.append("Status", "active");

        return this.$API
          .post(this.$UpdateAreaOfExpertise, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.$dialog
                .alert("You have successfully save the area of expertise")
                .then(function (dialog) {
                  //console.log("Closed");
                });
            }
          })
          .catch((error) => {
            if (error.response) {
              //console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      }
    },
    GoToPageNewSubjectGrade() {
      this.$router.push("/NewSubjectGrade?userID=" + this.$route.query.userId);
    },
    GoToPageTeacherProfession() {
      this.$router.push(
        "/TeacherProfession?userId=" + this.$route.query.userId
      );
    },
    GoToPageTeacherAcademicProfile() {
      this.$router.push(
        "/TeacherAcademicProfile?userId=" + this.$route.query.userId
      );
    },
    GoToPageTeacherAreaExpertise() {
      this.$router.push(
        "/TeacherAreaExpertise?userId=" + this.$route.query.userId
      );
    },
    GoToPageTeacherWorkBackground() {
      this.$router.push(
        "/TeacherWorkBackground?userId=" + this.$route.query.userId
      );
    },
    GoToPageClassAndGrade() {
      this.$router.push(
        "/TeacherClassGrade?userId=" + this.$route.query.userId
      );
    },
  },
};
</script>
